import React, { Component } from "react";
import moment from "moment";

/**
 * Common component for counter digits
 * @param {*} props : {parentClassName: string, digitData: number}
 * @returns : React Component
 */
const CounterDigit = ({ parentClassName, digitData }) => (
  <div className={'tb_flip_001 ' + parentClassName} >
    <a href="#">
      <div className="up">
        <div className="shadow"></div>
        {/* <div className="inn">{digitData}</div> */}
        <svg className="inn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20">
          <text className="" x="1.4" y="16.5">{digitData}</text>
        </svg>
      </div>
      <div className="down">
        <div className="shadow"></div>
        <svg className="inn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20">
          <text className="" x="1.4" y="16.5">{digitData}</text>
        </svg>
      </div>
    </a>
  </div>
);

const CounterDigitComp = ({ activeClass, digitData }) => (

  <div className="tb_flip_00 secondPlay">
    <CounterDigit parentClassName={activeClass ? "before" : "active"} digitData={digitData} />
    <CounterDigit parentClassName={activeClass ? "active" : "before"} digitData={digitData} />
  </div>


);

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00",
      timerType: "1",
      timerLabel: "",
      secondOnesChanged: true,
      secondTensChanged: false,
      minuteOnesChanged: true,
      minuteTensChanged: false,
      completed: false,
      countDownFormat: "1",
      completionMessage: "",
      daysItems: [],
      hoursItems: [],
      theme: "tb_dark",
    };
  }

  componentDidMount() {
    const {
      date,
      countDownFormat,
      completionMessage,
      timerType,
      timerLabel,
      theme,
    } = this.props;
    this.calculateTime();
    this.setState({
      date,
      countDownFormat,
      completionMessage,
      timerType,
      timerLabel,
      theme,
    });
    this.timerID = setInterval(() => this.calculateTime(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  componentDidUpdate(nextProps, previousProps) {

    const nexPropsDate = nextProps.date=='Invalid Date' ? new Date() : nextProps.date;

    if (
      nexPropsDate.toISOString() === previousProps.date.toISOString() &&
      nextProps.countDownFormat === previousProps.countDownFormat &&
      nextProps.completionMessage === previousProps.completionMessage &&
      nextProps.timerType === previousProps.timerType &&
      nextProps.timerLabel === previousProps.timerLabel &&
      nextProps.theme === previousProps.theme
    ) {
        return;
     }

    const {
      date,
      countDownFormat,
      completionMessage,
      timerType,
      timerLabel,
      theme,
    } = nextProps;

    this.setState({
      date,
      countDownFormat,
      completionMessage,
      timerType,
      timerLabel,
      theme,
    });
  }

  calculateTime() {
    const { days, seconds, minutes, hours, date } = this.state;
    const timeLeft =
      this.state.timerType == 1
        ? moment.duration(moment(date).diff(moment()))
        : moment.duration(moment().diff(moment(date)));
    if (timeLeft <= 0) {
      this.setState({ completed: true });
      return;
    }

    const daysLeft = Math.floor(timeLeft.asDays());
    let hoursLeft = timeLeft.hours();
    const minutesLeft = timeLeft.minutes();
    const secondsLeft = timeLeft.seconds();

    const daysItems = [];
    const daysDigitArr = (days > 10 ? "" + days : "0" + days).split("");
    const daysLeftDigitArr = (daysLeft > 10 ? "" + daysLeft : "0" + daysLeft).split("");

    daysLeftDigitArr.map((digit, step) =>
      daysItems.push(
        <CounterDigitComp
          activeClass={days == daysLeft ? true : daysDigitArr[step] !== digit}// to check if the digit value changed
          digitData={digit}
        />
      )
    );

    if (this.state.countDownFormat === "1") {
      hoursLeft += daysLeft * 24;
    }

    const hoursItems = [];
    const hoursDigitArr = (hours > 10 ? "" + hours : "0" + hours).split("");
    const hoursLeftDigitArr = (hoursLeft > 10 ? "" + hoursLeft : "0" + hoursLeft).split("");

    hoursLeftDigitArr.map((digit, step) =>
      hoursItems.push(
        <CounterDigitComp
          activeClass={hours == hoursLeft ? true : hoursDigitArr[step] !== digit}// to check if the digit value changed
          digitData={digit}
        />
      )
    );

    this.setState({
      daysItems,
      hoursItems,
      completed: false,
      secondOnesChanged: !this.state.secondOnesChanged,
      secondTensChanged:
        Math.floor(secondsLeft / 10) !== Math.floor(seconds / 10)
          ? !this.state.secondTensChanged
          : this.state.secondTensChanged,
      minuteTensChanged:
        Math.floor(minutesLeft / 10) !== Math.floor(minutes / 10)
          ? !this.state.minuteTensChanged
          : this.state.minuteTensChanged,
      minuteOnesChanged:
        Math.floor(minutesLeft % 10) !== Math.floor(minutes % 10)
          ? !this.state.minuteOnesChanged
          : this.state.minuteOnesChanged,
    });

    setTimeout(function () {
      this.setState({
        days: daysLeft > 10 ? daysLeft : `0${daysLeft}`,
        hours: hoursLeft > 10 ? hoursLeft : `0${hoursLeft}`,
        minutes: minutesLeft > 10 ? minutesLeft : `0${minutesLeft}`,
        seconds: secondsLeft > 10 ? secondsLeft : `0${secondsLeft}`,
      })
    }.bind(this), 800)
  }

  render() {
    const {
      countDownFormat,
      completed,
      completionMessage,
      daysItems,
      hoursItems,
      timerLabel,
      theme,
    } = this.state;
    const showSecond = countDownFormat === "1" || countDownFormat === "2";
    const showMinute = !(countDownFormat === "4" || countDownFormat === "5");
    const showHour = countDownFormat !== "5";
    const showDay = countDownFormat !== "1";
    return (
      <div className={`tb_countdown_body_class ${theme}`}>
       <div className="tb_countdown_label"> {timerLabel}</div>
        <div className="tb_countdown_timer">
          {!completed ? (
            <>
              {showDay ? (
                <div className={daysItems ? `tb_count_002 tb_count_d_${daysItems.length}` : 'tb_count_002'}>
                  <div className="tb_count_003">
                    {daysItems}
                  </div>
                  <div className="tb_time_unit tb_day_unit">
                    <div>Days</div>
                  </div>
                </div>

              ) : null}

              {showHour ? (

                <div className={hoursItems ? `tb_count_002 tb_count_h_${hoursItems.length}` : 'tb_count_002'}>
                  <div className="tb_count_003">
                    {hoursItems}
                  </div>
                  <div className="tb_time_unit tb_day_unit">
                    <div>Hours</div>
                  </div>
                </div>

              ) : null}

              {/* // Minutes */}
              {showMinute ? (
                <div className="tb_count_002">
                  <div className="tb_count_003">
                    <CounterDigitComp
                      activeClass={this.state.minuteTensChanged}
                      digitData={Math.floor(this.state.minutes / 10)}
                    />
                    <CounterDigitComp
                      activeClass={this.state.minuteOnesChanged}
                      digitData={this.state.minutes % 10}
                    />
                  </div>
                  <div className="tb_time_unit">
                    <div>Minutes</div>
                  </div>
                </div>
              ) : null}

              {/* // Seconds */}
              {showSecond ? (
                <div className="tb_count_002">
                  <div className="tb_count_003">
                    <CounterDigitComp
                      activeClass={this.state.secondTensChanged}
                      digitData={Math.floor(this.state.seconds / 10)}
                    />
                    <CounterDigitComp
                      activeClass={this.state.secondOnesChanged}
                      digitData={this.state.seconds % 10}
                    />
                  </div>
                  <div className="tb_time_unit">
                    <div>Seconds</div>
                  </div>
                </div>
              ) : null}
            </>
          ) : (
              <> {completionMessage !== '' ? <div className="tb_after_complete">{completionMessage}</div> :
                <>
                  <div className="tb_count_002">
                    <div className="tb_count_003">
                      <CounterDigitComp
                        activeClass={true}
                        digitData={0}
                      />
                      <CounterDigitComp
                        activeClass={true}
                        digitData={0}
                      />
                    </div>
                    <div className="tb_time_unit">
                      <div>Hours</div>
                    </div>
                  </div>

                  <div className="tb_count_002">
                    <div className="tb_count_003">
                      <CounterDigitComp
                        activeClass={true}
                        digitData={0}
                      />
                      <CounterDigitComp
                        activeClass={true}
                        digitData={0}
                      />
                    </div>
                    <div className="tb_time_unit">
                      <div>Minutes</div>
                    </div>
                  </div>

                  <div className="tb_count_002">
                    <div className="tb_count_003">
                      <CounterDigitComp
                        activeClass={true}
                        digitData={0}
                      />
                      <CounterDigitComp
                        activeClass={true}
                        digitData={0}
                      />
                    </div>
                    <div className="tb_time_unit">
                      <div>Seconds</div>
                    </div>
                  </div>

                </>
              } </>
            )}
        </div>
      </div>
    );
  }
}

export default Counter;
